import m from "../../geodata/es2015/belizeHigh";
window.am4geodata_belizeHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/belizeHigh.js
// module id = null
// module chunks = 